import { useGetMemberSummaryQuery } from '../state/api';
import { selectMemberById } from '../state/entitySelectors';
import { useAppSelector } from '../hooks/reduxHooks';
import MemberRecords from './member-records';

interface MemberRecordsContainerProps {
  memberId: string;
}

const MemberRecordsContainer = ({ memberId }: MemberRecordsContainerProps) => {
  // Fetch data with RTK Query
  useGetMemberSummaryQuery();

  // Use entity selector for O(1) lookup by ID (no more useMemo or array.find!)
  const member = useAppSelector((state) => selectMemberById(state, memberId));

  return <MemberRecords member={member} />;
};

export default MemberRecordsContainer;
